type Props = {
  error?: string | null;
};

export function LoginGate({ error }: Props) {
  return (
    <div className="login-gate" data-testid="login-gate">
      <div className="login-card">
        <div className="login-brand">
          spire<span className="dot">.</span> dashboard
        </div>
        <p className="login-sub">Acesso restrito ao time Spire.</p>

        {error && (
          <div className="login-error" data-testid="login-error">
            {error}
          </div>
        )}

        <a className="google-btn" href="/api/auth/google" data-testid="login-google">
          <GoogleG />
          <span>Continuar com Google</span>
        </a>

        <div className="login-footnote">
          Você precisa de uma conta com domínio autorizado. Se não conseguir entrar,
          peça acesso ao admin do workspace.
        </div>
      </div>
    </div>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8a12 12 0 1 1 0-24c3 0 5.8 1.1 7.9 3l5.7-5.7A20 20 0 1 0 24 44a20 20 0 0 0 20-20c0-1.2-.1-2.3-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.6 16.1 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7A20 20 0 0 0 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.8-2 13.4-5.3l-6.2-5.2C29.2 35 26.8 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.5 5C9.5 39.5 16.3 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.1 5.5l6.2 5.2C40.9 36.4 44 30.7 44 24c0-1.2-.1-2.3-.4-3.5z"
      />
    </svg>
  );
}
